// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { spacer8, spacer16, spacer24, spacer80, screenSmMin, screenMdMin, screenMdMax, screenLgMin, spacer32, screenXsMax, Type } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { Box, ImageAspectBox1x1, ButtonTertiaryAsLink, fadeInAnimation, withAnimationContext, DELAYS } from '../../ui';
import { withoutProps, fixHref, formatText, transformScaleUp } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeroBody = styled(Box).withConfig({
  displayName: "HeroBodyModule__HeroBody",
  componentId: "mj79sb-0"
})(["background-color:", ";color:", ";display:flex;flex-flow:row;justify-content:flex-start;height:auto;&.tallest{height:100%;}@media (max-width:", "){flex-direction:column;padding-bottom:", ";}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
}, screenXsMax, spacer32);
var ImageContainer = styled(ImageAspectBox1x1).withConfig({
  displayName: "HeroBodyModule__ImageContainer",
  componentId: "mj79sb-1"
})(["width:30%;display:flex;align-items:center;height:fit-content;align-self:center;@media (max-width:", "){width:40%;}@media (max-width:", "){width:100%;margin-bottom:", ";}"], screenMdMax, screenSmMin, spacer8);
var InnerText = styled.div.withConfig({
  displayName: "HeroBodyModule__InnerText",
  componentId: "mj79sb-2"
})(["padding-left:", ";width:50%;height:auto;max-width:600px;align-self:center;margin-top:auto;margin-bottom:auto;@media (min-width:", "){max-width:750px;margin-left:7%;}@media (max-width:", "){width:55%;}@media (max-width:", "){width:100%;max-width:none;padding-top:", ";padding-left:0px;margin:0px;}"], spacer80, screenLgMin, screenMdMax, screenSmMin, spacer16);
var Headline = withAnimationContext(styled(Type.h1).attrs({
  paddingBottom: '0.67em',
  variant: 'altoBrio',
  weight: 'bold'
}).withConfig({
  displayName: "HeroBodyModule__Headline",
  componentId: "mj79sb-3"
})(["", ";padding-bottom:", ";max-width:684px;@media (min-width:", "){text-align:left;}"], fadeInAnimation(DELAYS.FIRST), spacer16, screenMdMin));
var BodyText = withAnimationContext(styled(Type.h4).attrs({
  variant: 'cello'
}).withConfig({
  displayName: "HeroBodyModule__BodyText",
  componentId: "mj79sb-4"
})(["", ";padding-bottom:", ";@media (min-width:", "){padding-top:", ";}@media (max-width:", "){padding-bottom:", ";}"], fadeInAnimation(DELAYS.SECOND), spacer24, screenMdMin, spacer16, screenSmMin, spacer8));
var CTABtn = styled(withoutProps(ButtonTertiaryAsLink, 'textColor', 'backgroundColor')).withConfig({
  displayName: "HeroBodyModule__CTABtn",
  componentId: "mj79sb-5"
})(["padding-top:", ";&&{background-color:", ";color:", ";}a{color:", ";}a{color:", ";}@media (max-width:", "){padding-right:", ";padding-top:", ";padding-left:", ";width:100%;justify-content:center;}&:hover:not(:focus):not(:disabled){color:", ";", ";}"], spacer16, function (props) {
  return props.textColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundColor;
}, screenSmMin, spacer8, spacer16, spacer8, function (props) {
  return props.backgroundColor;
}, transformScaleUp);
var CTAContainer = withAnimationContext(styled.div.withConfig({
  displayName: "HeroBodyModule__CTAContainer",
  componentId: "mj79sb-6"
})(["", ";display:flex;padding-top:", ";padding-bottom:", ";@media (max-width:", "){width:100%;justify-content:center;}"], fadeInAnimation(DELAYS.THIRD), spacer16, spacer24, screenSmMin));
var TRACK_CAT = 'module-heroBody';
export var HeroBodyModule = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var headline = _ref.headline,
      bodyText = _ref.bodyText,
      image = _ref.image,
      ctaLink = _ref.ctaLink,
      ctaText = _ref.ctaText,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor;
  return /*#__PURE__*/_jsxs(HeroBody, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: [image && /*#__PURE__*/_jsx(ImageContainer, {
      children: /*#__PURE__*/_jsx(ContentfulImage, {
        asset: image
      })
    }), /*#__PURE__*/_jsxs(InnerText, {
      children: [headline && /*#__PURE__*/_jsx(Headline, {
        "data-testid": "hero-body-headline",
        dangerouslySetInnerHTML: {
          __html: formatText(headline)
        }
      }), bodyText && /*#__PURE__*/_jsx(BodyText, {
        dangerouslySetInnerHTML: {
          __html: formatText(bodyText)
        }
      }), ctaText && ctaLink && /*#__PURE__*/_jsx(CTAContainer, {
        children: /*#__PURE__*/_jsx(CTABtn, {
          textColor: textColor,
          href: fixHref(ctaLink),
          track: [TRACK_CAT, "CTA Link - ".concat(ctaText)],
          backgroundColor: backgroundColor,
          children: ctaText
        })
      })]
    })]
  });
});